export enum VendorTask {
    verifyAccount,
    refreshLinks,
    view,
}
